import { render, staticRenderFns } from "./SelectPlanComponent.vue?vue&type=template&id=c38964a8"
import script from "./SelectPlanComponent.vue?vue&type=script&lang=js"
export * from "./SelectPlanComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports